export default function(){

    //! legacy
    jQuery('.quantity').each(function () {
        var spinner = jQuery(this),
    
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');
    
        btnUp.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").eq(0).val(newVal);
            spinner.find("input").eq(0).trigger("change");
        });
    
        btnDown.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").eq(0).val(newVal);
            spinner.find("input").eq(0).trigger("change");
        });
    
    });

    // ! legacy
    jQuery(document).on('change', ".input-count", function (e) {
        var count = $(this).val();
        var product_id = $(this).data('product-id');
        $('.product-count-' + product_id).html(count);
    });
}